import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Button, Drawer, Spin } from "antd";

class EMDrawerForm extends Component {
	static propTypes = {
		visible           : PropTypes.bool.isRequired,
		onClose           : PropTypes.func.isRequired,
		formId            : PropTypes.any,
		isLoading         : PropTypes.bool,
		isSending         : PropTypes.bool,
		width             : PropTypes.any,
		title             : PropTypes.any,
		showBtnSave       : PropTypes.bool,
		btnSaveText       : PropTypes.any,
		btnSaveTextSending: PropTypes.any,
		drawerProps       : PropTypes.object,
	};

	static defaultProps = {
		isLoading         : false,
		isSending         : false,
		width             : 500,
		title             : "",
		showBtnSave       : true,
		btnSaveText       : "Salvar",
		btnSaveTextSending: "Salvando",
		drawerProps       : {},
	};

	render() {
		const {visible, formId, isLoading, isSending, width, title, showBtnSave, btnSaveTextSending, btnSaveText, drawerProps} = this.props;

		return (
			<Drawer
				visible={visible}
				className="drawer-form"
				width={width}
				destroyOnClose={true}
				maskClosable={!isLoading && !isSending}
				closable={false}
				keyboard={!isLoading && !isSending}
				placement="right"
				onClose={this.props.onClose}
				{...drawerProps}>
				<div className="drawer-form-inner">
					<div className="drawer-form-header">
						<Button className="btn-close" onClick={this.props.onClose} icon="close" disabled={isSending} />
						<div className="ant-drawer-title">{title}</div>
						{showBtnSave && <Button type="primary" form={formId} htmlType="submit" className="btn-save" loading={isSending} disabled={isLoading}>{isSending ? btnSaveTextSending : btnSaveText}</Button>}
					</div>
					<div className="drawer-form-body">
						{isLoading ? (
							<div className="text-center" style={{padding: 20}}>
								<Spin />
							</div>
						) : (
							<div className="drawer-form-body-inner">
								{this.props.children}
							</div>
						)}
					</div>
				</div>
			</Drawer>
		)
	}
}

export default EMDrawerForm;
